import createApiRequest from '@/lib/axios/createApiRequest';
import type PostOpportunity from '@/types/api/PostOpportunity';

export default function postOpportunity(data: PostOpportunity) {
  return createApiRequest({
    data,
    method: 'post',
    path: 'opportunities',
    throwErrors: true,
  });
}
